import type { SVGProps } from 'react';
const SvgIconMapPinLocation2 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={26} height={26} {...props}>
    <path
      fill="#3E704B"
      fillRule="evenodd"
      d="M13.448 22.55c2.009-2.514 6.59-8.608 6.59-12.03A7.52 7.52 0 0 0 12.52 3 7.52 7.52 0 0 0 5 10.52c0 3.422 4.582 9.516 6.591 12.03.482.6 1.375.6 1.857 0m-.929-14.537a2.506 2.506 0 1 1 0 5.013 2.506 2.506 0 0 1 0-5.013"
    />
  </svg>
);
export default SvgIconMapPinLocation2;
